import { render, staticRenderFns } from "./relativePreviewPopup.vue?vue&type=template&id=756eddd2&"
import script from "./relativePreviewPopup.vue?vue&type=script&lang=js&"
export * from "./relativePreviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports